export default __webpack_public_path__ + "static/media/STORYREEL (Default).fc63b43c.png";